import { render, staticRenderFns } from "./GroupAddress.vue?vue&type=template&id=0ca5f270&scoped=true"
import script from "./GroupAddress.vue?vue&type=script&lang=js"
export * from "./GroupAddress.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/group_information.css?vue&type=style&index=0&id=0ca5f270&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5f270",
  null
  
)

export default component.exports